import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import badgeSlotRecipe from './badge.recipe'
import {useSlotRecipe} from '@chakra-ui/react3'

/* Components */
import {Box} from '@chakra-ui/react'

const Badge = ({text, variant}) => {
    const recipe = useSlotRecipe({recipe: badgeSlotRecipe})
    const styles = useMemo(() => recipe({variant}), [recipe, variant])
    return (
        <Box data-testid="badge" {...styles.badge}>
            {text}
        </Box>
    )
}

Badge.displayName = 'Badge'

Badge.propTypes = {
    text: PropTypes.string.isRequired,
    variant: PropTypes.string
}

export default Badge
